import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { FileService } from 'app/modules/common/services/file.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ImportacionPlantillaModel } from '../../entities/importacion-plantilla-model';
import { StaffExcelFileImportModel } from '../../entities/staff-excel-file-import-model';
import { StaffImportViewService } from '../../services/staff-import-view.service';
import { StaffImportService } from '../../services/staff-import.service';
import { FormatoModalComponent } from '../popups/formato-modal/formato-modal.component';
import { FileFormatEnum } from 'app/modules/common/enums/file-format-enum';
@Component({
    selector: 'app-parameter-panel',
    templateUrl: './parameter-panel.component.html',
    styleUrls: ['./parameter-panel.component.scss'],
    standalone: false
})
export class ParameterPanelComponent implements OnInit, AfterViewInit {

  @Input() appExcelColumnPanel: any;
  importTemplates : ImportacionPlantillaModel[] =[];
  selectedImportTemplate: ImportacionPlantillaModel;
  

  importExcel = new UntypedFormControl();
  importTemplateDropdown = new UntypedFormControl();
  primeraFila = new UntypedFormControl();
  columnaClave = new UntypedFormControl();
  tipoImportacion = new UntypedFormControl();
  mes = new UntypedFormControl();
  anyo = new UntypedFormControl();
  hojas = new UntypedFormControl();

  fileBase64Value: string;
  fileChosen = false;
  fileChosenName = '';
  file: any;
  minimumYear: any;

  public FileFormatEnum = FileFormatEnum;

  constructor(public dialog: MatDialog,  
    private sharedService: SharedService,
    public staffImportService: StaffImportService,
    public staffImportViewService: StaffImportViewService,
    private changeDetectorRef: ChangeDetectorRef,
    private fileService: FileService) { }

  ngOnInit() {
    this.loadImportTemplates();
    this.setDefaultControlValues();
    this.staffImportViewService.isSaveExcelImportTemplate.subscribe((val) => {
      if(val && val.status && val.id){	
        this.loadImportTemplates(val.id);
      }
     });
  }

  ngAfterViewInit(): void {
  }

  loadImportTemplates(id?: any){
    this.staffImportService.GetImportTemplateList()
    .subscribe(res => {
      if(res){
        this.importTemplates = res.result;
        if(this.importTemplates.length >0){
          this.importTemplates.forEach(x=>x.hojas = x.hojas == null ? 1: x.hojas);
        }
        if(id){
          this.importTemplateDropdown.setValue(id);
        }
      }
    }, err => {
      console.error(err);
    })
  }

  setDefaultControlValues(){
    const currentDate = new Date();
    this.mes.setValue(currentDate.getMonth()+1); 
    this.anyo.setValue(currentDate.getFullYear()); 
    this.primeraFila.setValue(2);
    this.columnaClave.setValue(1);
    this.hojas.setValue(1); 
    this.tipoImportacion.setValue('1');
    this.minimumYear = new Date().getFullYear() - 5;
  }

  setImportTemplateControlValues(model: ImportacionPlantillaModel){
    if(model){
      this.importTemplateDropdown.setValue(model.importacionId);
      this.primeraFila.setValue(model.primeraFila);
      this.columnaClave.setValue(model.columnaClave);
      this.hojas.setValue(model.hojas);
      this.tipoImportacion.setValue(model.tipoImportacion.toString());
      this.selectedImportTemplate = model;
      this.staffImportService.GetColumnsForTemplate(model.importacionId)
      .subscribe(res => {   
        if(res){
          model.camposImportacion = res.result;
          this.selectedImportTemplate.camposImportacion = res.result;
          this.staffImportViewService.selectedCamposImportacionList.next(res.result);          
        }
    }, err => {
      console.error(err);
    });
    }
  }

  onChangeImportTemplate(selectedOption: MatSelectChange){
    const model = this.importTemplates.find(x=>x.importacionId ==  selectedOption.value);
    if(model){
      this.setImportTemplateControlValues(model);
    }
  }

  
  openFormatoModal(){
    if(!this.selectedImportTemplate){
      this.selectedImportTemplate = new ImportacionPlantillaModel();
    }
    this.selectedImportTemplate.primeraFila = this.primeraFila.value?  this.primeraFila.value : 2;
    this.selectedImportTemplate.hojas = this.hojas.value? this.hojas.value : 1;
    this.selectedImportTemplate.tipoImportacion = this.tipoImportacion.value? this.tipoImportacion.value: 1;
    this.selectedImportTemplate.columnaClave = this.columnaClave.value? this.columnaClave.value: 1;
    var selectedColumns = this.appExcelColumnPanel.getselectedColumnsData();
    const modalRef = this.dialog.open(FormatoModalComponent, { data : { 
      importTemplates:this.importTemplates, 
      selectedImportTemplates : this.selectedImportTemplate,
      selectedColumns: selectedColumns
    }});
  }

  deleteImportTemplate(){
      const dialogData = new ConfirmDialogModel('¿Eliminar el formato?', "");
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: dialogData
      });

      dialogRef.afterClosed().subscribe(responce => {
        if (responce) {
          this.staffImportService.deleteImportTemplate(this.importTemplateDropdown.value)
          .subscribe(res => {   
            if (res.code === 0) {
              this.sharedService.ShowSnackBar('Borrado exitosamente');
              this.loadImportTemplates();
              this.appExcelColumnPanel.clearExcelColumnList();
            } else {
              this.sharedService.ShowSnackBar('eliminar falla');
            }
          }, err => {
            this.sharedService.ShowSnackBar('eliminar falla');
            console.error(err);
          });
        }
      });
  }

  onFileChange(files: FileList) {
    this.fileChosen = files.length > 0;
    if (this.fileChosen) {
      this.fileChosenName = files[0].name;
    }
    if (files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    if (files.length) {
      this.file = "";
      this.fileBase64Value = "";
      this.readFile(files[0])
    }

  }
  private readFile(file) {
    let currentContext = this;
    let fileReader = new FileReader();
    fileReader.onload = function (event) {
      currentContext.file = file.name;
      currentContext.fileBase64Value = currentContext.fileService.arrayBufferToBase64(fileReader.result);
    }
      
    //if(currentContext.fileService.getFileExtention(file.type) == 'XLSX'){ 
      if (FileFormatEnum.StaffImportControllerTS.includes(currentContext.fileService.getFileExtention(file.type))) { 
      fileReader.readAsArrayBuffer(file);
    }else{
      this.fileChosenName = "";
      this.sharedService.ShowSnackBar('Upload only excel file', 'Okay', 4000);
    }
  }

  getParamterControls(){
    var model = new StaffExcelFileImportModel();
    model.importacionId = this.importTemplateDropdown.value;
    model.primeraFila = this.primeraFila.value;
    model.columnaClave = this.columnaClave.value;
    model.hojas = this.hojas.value;
    model.tipoImportacion = this.tipoImportacion.value;
    model.mes = this.mes.value;
    model.anyo = this.anyo.value;
    model.camposImportacion = this.appExcelColumnPanel.getselectedColumnsData();
    model.excelfile = this.fileBase64Value;

    return model;
  }

  setInvalidFormCOntrol(formControl: any){
    if(formControl == "anyo"){
      this.anyo.markAllAsTouched();
      this.anyo.setErrors({'incorrect': true});
    }
    if(formControl == "primeraFila"){
      this.primeraFila.markAllAsTouched();
      this.primeraFila.setErrors({'incorrect': true});
    }
    if(formControl == "columnaClave"){
      this.columnaClave.markAllAsTouched();
      this.columnaClave.setErrors({'incorrect': true});
    }
    if(formControl == "hojas"){
      this.hojas.markAllAsTouched();
      this.hojas.setErrors({'incorrect': true});
    }
  }

}
